// The code in this file will load on every page of your site

import wixWindow from 'wix-window';
$w.onReady(function () {
  let myLang = wixWindow.multilingual.currentLanguage; 
  if (myLang === 'he') {
    $w('#horizontalMenu1').hide();
    $w('#horizontalMenu2').show();
  } else {
    $w('#horizontalMenu2').hide();
    $w('#horizontalMenu1').show();
	  }
});